import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { ClickMeetingRoutingModule } from './click-meeting-routing';
import { ClickMeetingComponent } from './click-meeting.component';
import { ConferenceComponent } from './conference/conference.component';
import { CertificatesComponent } from './certificates/certificates.component';
import { OptionsClickMeetingComponent } from './options-click-meeting/options-click-meeting.component';
import { DetailClickMeetingComponent } from './detail-click-meeting/detail-click-meeting.component';
import { SearchPostClickMeetingComponent } from './search-post-click-meeting/search-post-click-meeting.component';
import { AgChartsAngularModule } from 'ag-charts-angular';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ClickMeetingRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    AgChartsAngularModule
  ],
  declarations: [
    ClickMeetingComponent,
    ConferenceComponent,
    CertificatesComponent,
    OptionsClickMeetingComponent,
    DetailClickMeetingComponent,
    SearchPostClickMeetingComponent
  ],
})
export class ClickMeetingModule { }
